import { formatUnits } from "viem"

import { ClSet, RawIchiLensData, ValuesIchiLensRaw } from "./types"

const BIGINT_ZERO = BigInt(0)

export const mapRawIchiLensData = (values: bigint[], flipLensTokens = false): RawIchiLensData => {
  const reserve0 = flipLensTokens ? values?.[1] : values?.[0]
  const reserve1 = flipLensTokens ? values?.[0] : values?.[1]
  const userToken0Balance = flipLensTokens ? values?.[7] : values?.[6]
  const userToken1Balance = flipLensTokens ? values?.[6] : values?.[7]
  const userToken0GuardAllowance = flipLensTokens ? values?.[11] : values?.[10]
  const userToken1GuardAllowance = flipLensTokens ? values?.[10] : values?.[11]
  return {
    reserve0: reserve0 ?? BIGINT_ZERO,
    reserve1: reserve1 ?? BIGINT_ZERO,
    totalSupply: values?.[2] ?? BIGINT_ZERO,
    totalStaked: values?.[3] ?? BIGINT_ZERO,
    tvl: values?.[4] ?? BIGINT_ZERO,
    apr: values?.[5] ?? BIGINT_ZERO,
    userToken0Balance: userToken0Balance ?? BIGINT_ZERO,
    userToken1Balance: userToken1Balance ?? BIGINT_ZERO,
    userAlmWalletBalance: values?.[8] ?? BIGINT_ZERO,
    userAlmStakedBalance: values?.[9] ?? BIGINT_ZERO,
    userToken0GuardAllowance: userToken0GuardAllowance ?? BIGINT_ZERO,
    userToken1GuardAllowance: userToken1GuardAllowance ?? BIGINT_ZERO,
    userAlmFarmAllowance: values?.[12] ?? BIGINT_ZERO,
  }
}

export const processRawIchiLensData = (raw: RawIchiLensData, clSet: ClSet): ValuesIchiLensRaw => {
  return {
    /**
     * percentage values are always 0-1 based
     * @todo change this to an actual number like 37.34% instead of 0.3734
     */
    apr: Number(formatUnits(raw.apr, 18)) / 100,
    tvl: Number(formatUnits(raw.tvl, 18)),
    reserve0: { wei: raw.reserve0, decimals: clSet.token0?.decimals },
    reserve1: { wei: raw.reserve1, decimals: clSet.token1?.decimals },
    totalSupply: { wei: raw.totalSupply, decimals: 18 },
    totalStaked: { wei: raw.totalStaked, decimals: 18 },
    userToken0Balance: { wei: raw.userToken0Balance, decimals: clSet.token0?.decimals },
    userToken1Balance: { wei: raw.userToken1Balance, decimals: clSet.token1?.decimals },
    userAlmWalletBalance: { wei: raw.userAlmWalletBalance, decimals: 18 },
    userAlmStakedBalance: { wei: raw.userAlmStakedBalance, decimals: 18 },
    userToken0GuardAllowance: { wei: raw.userToken0GuardAllowance, decimals: clSet.token0?.decimals },
    userToken1GuardAllowance: { wei: raw.userToken1GuardAllowance, decimals: clSet.token1?.decimals },
    userAlmFarmAllowance: { wei: raw.userAlmFarmAllowance, decimals: 18 },
  }
}
